"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _RequestInfo = _interopRequireDefault(require("./tabs/RequestInfo"));

var _BreadcrumbHelper = _interopRequireDefault(require("../../../../util/BreadcrumbHelper"));

var _index = require("../../../../index");

var _AppTabs = _interopRequireDefault(require("../../../../components/crud/tabs/AppTabs"));

var _KycProcessModel = _interopRequireDefault(require("../../models/KycProcessModel"));

var _ServiceCalls = _interopRequireDefault(require("./tabs/ServiceCalls"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var KYCRequestDetails = /*#__PURE__*/function (_Component) {
  _inherits(KYCRequestDetails, _Component);

  function KYCRequestDetails() {
    var _this;

    _classCallCheck(this, KYCRequestDetails);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(KYCRequestDetails).call(this));

    _BreadcrumbHelper["default"].setCrumbs([{
      label: 'KYC',
      link: '/kyc'
    }, {
      label: 'KYC Requests',
      link: '/kyc/requests'
    }]);

    return _this;
  }

  _createClass(KYCRequestDetails, [{
    key: "tabClick",
    value: function tabClick(tab) {
      this.setState({
        activeTab: tab
      });
    }
  }, {
    key: "_getTabs",
    value: function _getTabs(process) {
      return [{
        id: 'basic',
        icon: 'info',
        title: 'Request Info',
        component: _react["default"].createElement(_RequestInfo["default"], {
          process: process
        })
      }, {
        id: 'serviceCalls',
        icon: 'info',
        title: 'Service Calls',
        component: _react["default"].createElement(_ServiceCalls["default"], {
          user: this.props.user,
          process: process
        })
      }];
    }
  }, {
    key: "_renderContent",
    value: function _renderContent(processDetails) {
      _BreadcrumbHelper["default"].addCrumb('Details: ' + processDetails.id);

      return _react["default"].createElement("div", null, _react["default"].createElement("h1", null, _react["default"].createElement("i", {
        className: "fa fa-info",
        "aria-hidden": "true"
      }), " KYC Process: ", processDetails.id), _react["default"].createElement(_AppTabs["default"], {
        activeTab: 'basic',
        tabs: this._getTabs(processDetails)
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return _react["default"].createElement("div", {
        className: "dashboard-management"
      }, _react["default"].createElement(_index.AppFetcher, {
        model: _KycProcessModel["default"],
        id: this.props.match.params.id,
        renderContent: function renderContent(record) {
          return _this2._renderContent(record);
        }
      }));
    }
  }]);

  return KYCRequestDetails;
}(_react.Component);

exports["default"] = KYCRequestDetails;